import { observer } from "mobx-react";
import MainStore from "../../stores/MainStore";
import './index.css';
import { closeIcon, contentTypeDocIcon, contentTypeImageIcon, downloadIcon } from "../../assets";
import ImageDownloader from "../ImageDownloader";


const ImageModal = () => {

  const imageModalData = MainStore.imageModalData;

  if (!imageModalData) {
    return null;
  }

  const contentType = imageModalData.contentType;
  const filename = imageModalData.filename;
  const sliceLength = 20;


  return (
    <div className="image-modal" >
      <div className="image-modal-content">
        <div className="image-modal-content-inner">
          <div className="image-modal-buttons" >
            <div className="image-modal-content-inner-content-type">
              <img src={contentType.startsWith('image') ? contentTypeImageIcon : contentTypeDocIcon} alt="image" className="image-modal-content-inner-icon" />
              <span>{filename.length > sliceLength ? filename.slice(0, sliceLength) + '...' : filename}</span>
            </div>
            <ImageDownloader imageData={imageModalData} />
            <button className="button-round button-round-medium" onClick={() => MainStore.setImageModalData(null)}>
              <img src={closeIcon} alt="download" />
            </button>
          </div>
          <img src={imageModalData.presignedUrl} alt="image" />
        </div>
      </div>
    </div>
  );
}

export default observer(ImageModal);